import TechStack from './TechStack';

const Project = ({ images, title, description, techs, codeLink, liveLink, appStoreLink, playStoreLink, handleClick }) => (
  <div className="project">
    <div className="project-pic-container" style={{ "--image-count": images.length }}>
      {images.map((imgSrc, index) => (
        <img
          key={index}
          onClick={handleClick}
          className="project-pic"
          src={imgSrc}
          alt={`${title} ${index + 1}`}
        />
      ))}

      {/* Hover container over the entire image grid */}
      <div className="hover-container">
        {codeLink && (
          <a target="_blank" href={codeLink} rel="noreferrer" className="hover-button">
            View Code
          </a>
        )}
        {liveLink && (
          <a target="_blank" href={liveLink} className="hover-button" rel="noreferrer">
            Live Demo
          </a>
        )}
        {appStoreLink && (
          <a target="_blank" href={appStoreLink} rel="noreferrer" className="store-badge">
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on the App Store"
              style={{ height: '40px' }}
            />
          </a>
        )}
        {playStoreLink && (
          <a target="_blank" href={playStoreLink} rel="noreferrer" className="store-badge">
            <img
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              style={{ height: '60px' }}
            />
          </a>
        )}
      </div>
    </div>

    <div className="project-info">
      <h6>{title}</h6>
      <p>{description}</p>
      <TechStack items={techs} />
    </div>
  </div>
);

export default Project;
